export default {
  'menu.workbench': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.template': 'テンプレート',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
  'menu.luole-admin.dashboard': 'ダッシュボード',
  'menu.luole-admin.architect-talent-ops': '人材側',
  'menu.luole-admin.architect-talent-ops.overview': '運営概要',
  'menu.luole-admin.architect-talent-ops.applications': '応募詳細',
  'menu.luole-admin.architect-talent-ops.luole-admin.architect-talent-ops.overview':
    '運営概要',
  'menu.luole-admin.architect-talent-ops.luole-admin.architect-talent-ops.applications':
    '応募詳細',
  'menu.luole-admin.architect-talent-ops.luole-admin.member.management':
    '人材プール',
  'menu.luole-admin.architect-talent-ops.luole-admin.inviteManagement':
    '招待管理',
  'menu.luole-admin.architect-talent-ops.luole-admin.schoolShowcase':
    '学校風采',
  'menu.luole-admin.architect-talent-ops.luole-admin.carousel.management':
    'カルーセル',
  'menu.luole-admin.architect-talent-ops.luole-admin.contentMarketing.management':
    'コンテンツマーケティング',
  'menu.luole-admin.recruitment-assistant-ops': '企業側',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.overview':
    '運営概要',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.ai-job-monitor':
    'AI求人マッチング',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.enterprise-portrait':
    '企業分析',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.enterprise-portrait.detail':
    '企業分析詳細',
  'menu.luole-admin.campus-ops': '大学運営',
  'menu.luole-admin.institution.verify': '大学認証審査',
  'menu.luole-admin.campus-ops.luole-admin.institution.verify': '大学認証審査',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.campus-ops':
    '大学運営',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.enterprise.list':
    '企業ライブラリ',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.enterprise.users':
    '企業ユーザー',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.enterprise.verify':
    '企業認証',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.institution.verify':
    '大学認証審査',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.campus-ops.luole-admin.institution.verify':
    '大学認証審査',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.demoReservation':
    '企業デモ予約',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.userFeedback':
    'ユーザーフィードバック',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.registrationChannels':
    'チャネル管理',
  'menu.luole-admin.recruitment': '採用管理',
  'menu.luole-admin.activity': 'イベント管理',
  'menu.luole-admin.system': 'システム設定',
  'menu.luole-admin.system.role-permissions': 'ロール権限',
  'menu.luole-admin.system.members': 'メンバー管理',
  'menu.luole-admin.content': 'コンテンツ設定',
  'menu.luole-admin.feedback': 'フィードバック管理',
  'menu.luole-admin.analytics.recruitment': '採用運営ダッシュボード',
  'menu.luole-admin.job.management': '求人管理',
  'menu.luole-admin.member.management': '人材プール',
  'menu.luole-admin.inviteManagement': '招待管理',
  'menu.luole-admin.enterprise': '企業管理',
  'menu.luole-admin.enterprise.list': '企業ライブラリ',
  'menu.luole-admin.enterprise.users': '企業ユーザー',
  'menu.luole-admin.enterprise.verify': '企業認証',
  'menu.luole-admin.resume.templates': '履歴書テンプレート',
  'menu.luole-admin.job-fair.management': '求人フェア',
  'menu.luole-admin.schoolShowcase': '学校風采',
  'menu.luole-admin.schoolShowcase.create': '学校風采を作成',
  'menu.luole-admin.schoolShowcase.edit': '学校風采を編集',
  'menu.luole-admin.global.dictionary': '職種カテゴリ',
  'menu.luole-admin.carousel.management': 'カルーセル',
  'menu.luole-admin.contentMarketing.management': 'コンテンツマーケティング',
  'menu.luole-admin.contentMarketing.create': 'コンテンツ作成',
  'menu.luole-admin.contentMarketing.edit': 'コンテンツ編集',
  'menu.luole-admin.task.management': 'タスク管理',
  'menu.luole-admin.forumRegistration': 'フォーラム登録',
  'menu.luole-admin.jobFairRegistration': '求人フェア登録',
  'menu.luole-admin.demoReservation': 'デモ予約',
  'menu.luole-admin.userFeedback': 'ユーザーフィードバック',
  'menu.luole-admin.registrationChannels': 'チャネル管理',
  'menu.luole-admin.userFeedback.detail': 'フィードバック詳細',
};
